import React from 'react';
import { Box, Heading } from '@chakra-ui/react';
import { truncate } from 'utils/address';
import { Text } from '@chakra-ui/react';
import { useWeb3React } from 'hooks/web3';

import {
  __CRUCIBLE_IMAGE_LOADING,
  __CRUCIBLE_IMAGE_UNAVAILABLE,
  __CRUCIBLE_IMAGE_UNREVEALED
} from 'utils/constants';

const CrucibleImage = (props: {
  address: string;
  isBackground?: boolean;
  instanceNumber?: number;
  children?: any;
}) => {
  const { chainId = 1 } = useWeb3React();
  const [loadedSrc, setLoadedSrc] = React.useState<string | null>(
    __CRUCIBLE_IMAGE_LOADING
  );
  const address = props.address.toLowerCase();
  const url = `https://crucible-artwork.storage.googleapis.com/${chainId}/${address}.jpg`;

  const fallbackImage = async () => {
    // TODO: Remove when sidechain artwork is available
    if (chainId !== 1) {
      setLoadedSrc(__CRUCIBLE_IMAGE_UNREVEALED);
      return;
    }

    setLoadedSrc(__CRUCIBLE_IMAGE_UNAVAILABLE);
  };

  React.useEffect(() => {
    setLoadedSrc(__CRUCIBLE_IMAGE_LOADING);

    const handleLoad = () => setLoadedSrc(url);
    const image = new Image();

    image.addEventListener('load', handleLoad);
    image.src = url;

    image.onerror = async () => {
      await fallbackImage();
    };
    return () => {
      image.removeEventListener('load', handleLoad);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.address, url]);

  if (props.isBackground) {
    return (
      <Box
        borderRadius={'xl'}
        height={'100%'}
        width={'100%'}
        backgroundImage={`  linear-gradient(to bottom, rgba(10,14,25,0) 72%, rgba(10,14,25,.5) 80%, rgba(10,14,25,1) 100%), url(${
          loadedSrc ?? __CRUCIBLE_IMAGE_UNAVAILABLE
        })`}
        backgroundPosition='center'
        backgroundSize={'cover'}
        display='flex'
        justifyContent={'center'}
        alignItems='flex-end'
      >
        <Heading size='md' m={5} textAlign='center'>
          {props.children ? props.children : truncate(props.address)}
          <Text fontSize='sm' fontWeight='normal'>
            #{props.instanceNumber}
          </Text>
        </Heading>
      </Box>
    );
  }

  return (
    <Box
      as='img'
      width={'100%'}
      borderRadius={['xl']}
      maxWidth={'300'}
      src={loadedSrc ?? __CRUCIBLE_IMAGE_UNAVAILABLE}
    />
  );
};

export default CrucibleImage;
